import React from 'react';
import PropTypes, { func } from 'prop-types';
import {
  Body1,
  Button,
  makeStyles,
  mergeClasses,
  shorthands,
  tokens,
} from '@fluentui/react-components';

const useTextAssetPlaceholderStyles = makeStyles({
  root: {
    width: '100%',
    ...shorthands.borderStyle('solid'),
    ...shorthands.border(tokens.strokeWidthThin),
    ...shorthands.borderWidth(tokens.strokeWidthThin),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    ...shorthands.borderColor(tokens.colorNeutralStrokeAccessible),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: tokens.spacingVerticalS,
    ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalM),

    '& > span': {
      textAlign: 'center',
    },
  },
});

export const TextAssetPlaceholder = ({ i18n, placeholder, onEdit }) => {
  const classes = useTextAssetPlaceholderStyles();

  return (
    <div className={mergeClasses('display-ads-text-assets-placeholder', classes.root)}>
      <Body1>
        {placeholder
          ? i18n.getString(placeholder)
          : i18n.getString(_TL_('Multiple options, editing will override for all texts'))}
      </Body1>
      <Button size="small" onClick={onEdit}>{i18n.getString(_TL_('Click to edit'))}</Button>
    </div>
  );
};

TextAssetPlaceholder.propTypes = {
  i18n: PropTypes.shape({ getString: func, getLocale: func }).isRequired,
  placeholder: PropTypes.string,
  onEdit: PropTypes.func,
};

TextAssetPlaceholder.defaultProps = {
  placeholder: '',
  onEdit: () => {},
};
